<template xmlns:v-bind="http://www.w3.org/1999/xhtml" xmlns:v-el="http://www.w3.org/1999/xhtml">
  <ul
    role="tablist"
    class="tab-list">
    <TabHeader
      v-for="tab in tabs"
      :key="tab.id"
      :tab="tab"
      :active="tab != null && innerActiveTab != null && tab.title === innerActiveTab.title"
      @tab-clicked="markAsActive(tab)">
      <template #icon-wrapper-right="{ tabId }">
        <slot
          name="icon-wrapper-right"
          :tab-id="tabId" />
      </template>
    </TabHeader>
  </ul>
</template>

<script lang="ts" setup>
  import { onMounted, ref, watch } from 'vue';

  import TabHeader from '@/org-app/components/controls/TabHeader.vue';

  export interface Tab {
    id: string;
    title: string;
    icon?: any;
    count?: number;
    disabled?: boolean;
    disabledTooltip?: string;
  }

  interface IProps {
    tabs: Tab[];
    activeTab?: Tab;
  }

  const props = withDefaults(defineProps<IProps>(), {
    activeTab: null,
    tabs: () => [],
    size: 'md',
  });

  const emit = defineEmits(['tabChanged']);

  const innerActiveTab = ref<Tab | null>(null);

  function markAsActive(tab: Tab): void {
    innerActiveTab.value = tab;
    emit('tabChanged', tab);
  }

  function selectDefaultTab(): void {
    if (props.tabs.length === 0) {
      return;
    }
    if (props.activeTab) {
      innerActiveTab.value = props.activeTab;
    } else {
      [innerActiveTab.value] = props.tabs;
    }
  }

  function setActiveTabID(id) {
    innerActiveTab.value = props.tabs.find((x) => x.id === id);
  }

  watch(
    () => props.activeTab,
    () => {
      innerActiveTab.value = props.activeTab;
    },
  );

  watch(
    () => props.tabs,
    () => {
      if (innerActiveTab.value == null) {
        selectDefaultTab();
      }
    },
  );

  onMounted(() => {
    selectDefaultTab();
  });

  defineExpose({
    setActiveTabID,
  });
</script>

<style lang="scss" rel="stylesheet/scss" scoped>
  @use '@/styles/variables' as *;

  #app {
    ul {
      border-bottom: 0.1rem solid var(--secondaryColorDesaturatedLighten30); //#8cb7ce;

      padding-left: 0;
      text-align: center;
      list-style: none;
      display: flex;
      justify-content: center;
    }
  }
</style>
